import { PageDocument, SpeakerDocument } from '../types/types.generated'
import { resolver } from './resolver'

export const routeResolver = (page: PageDocument | SpeakerDocument): string => {
  const { uid, type } = page
  return resolver(uid, type)
}
